import axios from "./axios"

import store from '../store'

/**
 * 獲取用戶學習的課程
 */
const list = (lang = 'ZH_TW') => {
    return axios.get(`${store.state.PCourseId ? '/user-courses' : '/user-course/versions'}?lang=${lang}`).then(res => res.data)
}

/**
 * 是否有學習過課程
 * @param {*} lang 
 */
const findLastByUser = (lang = 'ZH_TW') => {
    return axios.get(`/user-courses/last?lang=${lang}`).then(res => res.data)
}

/**
 * 記錄用戶學習課件
 * @param {*} courseWareId 
 */

const addUserCourseWare = courseWareId => {
    return axios.get(`${store.state.PCourseId ? '/user-courses' : '/user-course/versions'}/wares/${courseWareId}`).then(res => res.data)
}

/**
 * 記錄用戶學習課程
 * @param {*} courseId 
 */
const addUserCourse = courseId => {
    return axios.get(`${store.state.PCourseId ? '/user-courses' : '/user-course/versions'}/${courseId}`).then(res => res.data)
}

/**
 * 獲取課程最近的學習的章節
 * @param {*} courseId 
 * @param {*} lang 
 */
const findLastByUserAndCourse = (courseId, lang = 'ZH_TW') => {
    return axios.get(`${store.state.PCourseId ? '/user-courses' : '/user-course/versions'}/${courseId}/last?lang=${lang}`).then(res => res.data)
}

export default {
    list,
    findLastByUser,
    addUserCourseWare,
    addUserCourse,
    findLastByUserAndCourse
}